import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointUp,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgArrowBack from 'src/components/Svgs/SvgArrowBack'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns from 'src/localization/Trns'
import { homeUrl } from 'src/navigation/urls'
import { selectShowSidenavLargeFromState } from 'src/redux/selectors/app.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import { css } from 'styled-components'

interface NotFoundTopContentProps {
  className?: string
  isSmall?: boolean
}

const NotFoundTopContent: React.FC<NotFoundTopContentProps> = (
  props,
): React.ReactElement => {
  const showSidenavLarge = useSelector(selectShowSidenavLargeFromState)
  const location = useSelector(selectLocationFromState)
  const notFoundImageSrc = useColorOrGrayscaleImage(ImageNames.NotFound)

  const history = useHistory()

  return (
    <div
      css={css`
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
      `}
    >
      <HoverableLink
        css={css`
          position: absolute;
          left: 0;
          display: none;

          ${!showSidenavLarge &&
          !props.isSmall &&
          css`
            display: block;
          `}

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            ${!props.isSmall &&
            css`
              display: block;
            `}
          `)}
        `}
        to={location.key === undefined ? homeUrl() : undefined}
        onClick={
          history.action === 'POP' && location.key !== undefined
            ? (): void => {
                history.goBack()
              }
            : (): void => {
                return
              }
        }
        ariaLabel="Click here to go back"
      >
        <SvgArrowBack
          css={css`
            transform: scale(1.5);
            transform-origin: top left;
          `}
        />
      </HoverableLink>
      <div
        className={props.className}
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;

          ${getBreakpointUp(breakpointSizes.SM)(css`
            width: 420px;
          `)}
        `}
      >
        <img
          src={notFoundImageSrc}
          alt={''}
          css={css`
            ${getBreakpointDown(breakpointSizes.XSM)(css`
              width: 100px;
            `)}
            ${!!props.isSmall &&
            css`
              width: 100px;
            `}
          `}
        />
        <span
          css={css`
            margin-top: 30px;
            ${getFontCss(
              40,
              themeConstants.colors.highlight,
              styleConstants.fontFamilies.medium,
            )}
            text-align: center;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              ${getFontCss(
                24,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.medium,
              )}
              margin-top: 10px;
            `)}

            ${!!props.isSmall &&
            css`
              ${getFontCss(
                24,
                themeConstants.colors.highlight,
                styleConstants.fontFamilies.medium,
              )}
              margin-top: 10px;
            `}
          `}
        >
          <Trns source={'Oops!'} />
        </span>
        <span
          css={css`
            margin-top: 30px;
            ${getFontCss(
              32,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )}
            text-align: center;

            ${getBreakpointDown(breakpointSizes.XSM)(css`
              ${getFontCss(
                20,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )}
              margin-top: 10px;
            `)}

            ${!!props.isSmall &&
            css`
              ${getFontCss(
                20,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )}
              margin-top: 10px;
            `}
          `}
        >
          <Trns source={"The page you're looking for declined to show."} />
        </span>
      </div>
    </div>
  )
}

export default NotFoundTopContent
